export enum LoadStatus {
    None,
    Loading,
    Error,
    Ok,
}
